import { render, staticRenderFns } from "./ZonaDescarga.vue?vue&type=template&id=50a5b3e8&scoped=true"
import script from "./ZonaDescarga.vue?vue&type=script&lang=js"
export * from "./ZonaDescarga.vue?vue&type=script&lang=js"
import style0 from "./ZonaDescarga.vue?vue&type=style&index=0&id=50a5b3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5b3e8",
  null
  
)

export default component.exports